export type WhitelistedSuppliersForDeliveryOption = {
  manualFulfillmentRoutingSuppliers: string[];
  automatedAssociatePickupSuppliers: string[];
};

function normalizeIdList(raw: unknown): string[] {
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw
    .map((id) => String(id ?? "").trim().toLowerCase())
    .filter(Boolean);
}

function parseJsonTolerant(raw: string): unknown {
  try {
    return JSON.parse(raw);
  } catch {
    try {
      const withQuotedKeys = raw.replace(
        /([{,]\s*)([A-Za-z_][A-Za-z0-9_]*)(\s*:)/g,
        '$1"$2"$3',
      );
      return JSON.parse(withQuotedKeys);
    } catch {
      return null;
    }
  }
}

/**
 * Parses `whitelisted_suppliers_for_restricted_delivery_option` mobile config.
 */
export function parseWhitelistedSuppliersForDeliveryOption(
  raw: unknown,
): WhitelistedSuppliersForDeliveryOption {
  const empty: WhitelistedSuppliersForDeliveryOption = {
    manualFulfillmentRoutingSuppliers: [],
    automatedAssociatePickupSuppliers: [],
  };

  if (raw == null || raw === "") {
    return empty;
  }

  let parsed: any = raw;
  if (typeof raw === "string") {
    parsed = parseJsonTolerant(raw);
    if (parsed == null) {
      return empty;
    }
  }

  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
    return empty;
  }

  return {
    manualFulfillmentRoutingSuppliers: normalizeIdList(
      parsed.manual_fulfillment_routing_suppliers ??
        parsed.manualFulfillmentRoutingSuppliers,
    ),
    automatedAssociatePickupSuppliers: normalizeIdList(
      parsed.automated_associate_pickup_suppliers ??
        parsed.automatedAssociatePickupSuppliers,
    ),
  };
}

export function isSourceSupplierInList(
  sourceSupplierId: string | null | undefined,
  supplierIds: string[] | null | undefined,
): boolean {
  if (!sourceSupplierId?.trim() || !supplierIds?.length) {
    return false;
  }
  const normalized = sourceSupplierId.trim().toLowerCase();
  return supplierIds.some((id) => id.trim().toLowerCase() === normalized);
}
